module.exports = ".martop20{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/personnel-details/Personnels/personnel-hestory/personnel-hestory.component.css
// module id = ./src/app/pages/functions/personnel-details/Personnels/personnel-hestory/personnel-hestory.component.css
// module chunks = main